export default __webpack_public_path__ + "static/clientSale-861d8484edc864800759b9f643f1b5b5.gif";